const userspecialdiet = {
    getlist: 'userspecialdiet/getlist',
    add: 'userspecialdiet/add',
    update: 'userspecialdiet/update',
    remove: 'userspecialdiet/remove',
    get: 'userspecialdiet/get-by-admin',
}
export default userspecialdiet
